import { readonly, ref } from "vue";

export interface Toast {
  id: number;
  message: string;
  tone: "ok" | "bad" | "info";
}

const items = ref<Toast[]>([]);
let nextId = 1;

/** La fila de avisos de toda la app. Son de pasadita y nunca traban la interfaz. */
export function useToast() {
  function push(message: string, tone: Toast["tone"] = "info", ms = 4000): void {
    const id = nextId++;
    items.value = [...items.value, { id, message, tone }];
    setTimeout(() => dismiss(id), ms);
  }

  function dismiss(id: number): void {
    items.value = items.value.filter((toast) => toast.id !== id);
  }

  return {
    toasts: readonly(items),
    push,
    dismiss,
    success: (message: string) => push(message, "ok"),
    error: (message: string) => push(message, "bad", 7000),
    info: (message: string) => push(message, "info"),
  };
}
